module.exports = __webpack_public_path__ + "img/Acrcx_dashbord_1.4c47f2bd.jpg";